import { useI18n } from 'vue-i18n';
import { useMsgBox } from '@deepcloud/deep-ui-lib';
import type { MsgBoxOptions } from '@deepcloud/deep-ui-lib';

export function useDeepIdWebCancelConfirm() {
  const i18n = useI18n();
  const deepMsgBox = useMsgBox();

  /** Resolves true when the user really wants to leave the embedded DeepID flow. */
  async function confirmCancel(): Promise<boolean> {
    const options: MsgBoxOptions = {
      title: i18n.t('text.identity.deep_id_web.cancel_dialog.title'),
      content: i18n.t('text.identity.deep_id_web.cancel_dialog.text'),
      btnActions: {
        cancel: {
          text: i18n.t('text.identity.deep_id_web.cancel_dialog.continue')
        },
        confirm: {
          text: i18n.t('text.identity.deep_id_web.cancel_dialog.confirm')
        }
      },
      autoCloseOnActionClick: false
    };

    const { action, close } = await deepMsgBox.warning(options);
    close();

    return action === 'confirm';
  }

  return { confirmCancel };
}
